export default __webpack_public_path__ + "static/chart-market-en-4e83d28c6b17ff9b04fb686c93e15dac.svg";